import React from 'react';
import { motion } from 'framer-motion';
import { Star, Heart } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Sofía C.',
    location: 'La Plata',
    quote: 'El Tomo 4 lo leí llorando. Por primera vez alguien me explicaba el sueño de mi bebé prematuro con edad corregida. No me sentí sola.'
  }, {
    name: 'Roberto M.',
    location: 'Buenos Aires',
    quote: 'El Tomo del Padre fue lo que nunca esperé encontrar. Por fin alguien habló de lo que nos pasa a nosotros también.'
  }, {
    name: 'Pablo A.',
    location: 'Neuquén',
    quote: 'El Kit de Emergencia en el celular a las 3 AM fue lo más útil que tuve en meses. Seguí el árbol y listo.'
  }, {
    name: 'María R.',
    location: 'Córdoba',
    quote: 'En 10 días mi bebé de 5 meses pasó de 7 despertares a 2. No lo podía creer.'
  }];
  return <section className="py-20 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-255">
      <div className="text-center mb-12" data-id="element-256">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="inline-flex items-center justify-center gap-3 mb-4" data-id="element-257">
          <Heart className="w-8 h-8 text-red-400 fill-red-400" data-id="element-258" />
          <h2 className="text-3xl md:text-4xl font-bold text-white" data-id="element-259">
            FAMILIAS QUE YA LO TIENEN
          </h2>
        </motion.div>
      </div>

      <div className="grid md:grid-cols-2 gap-6" data-id="element-260">
        {testimonials.map((t, index) => <motion.div key={index} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5,
        delay: index * 0.1
      }} className="bg-navy-800/40 border border-navy-700 p-8 rounded-2xl" data-id="element-261">
            <div className="flex gap-1 mb-4" data-id="element-262">
              {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-gold-400 text-gold-400" data-id="element-263" />)}
            </div>
            <p className="text-lg text-blue-50 italic mb-6 leading-relaxed" data-id="element-264">
              "{t.quote}"
            </p>
            <div className="flex items-center gap-3" data-id="element-265">
              <div className="w-10 h-10 rounded-full bg-navy-700 flex items-center justify-center text-gold-400 font-bold" data-id="element-266">
                {t.name.charAt(0)}
              </div>
              <div data-id="element-267">
                <p className="text-white font-bold" data-id="element-268">{t.name}</p>
                <p className="text-blue-200/60 text-sm" data-id="element-269">— {t.location}</p>
              </div>
            </div>
          </motion.div>)}
      </div>
    </section>;
}